import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_REVENUE_CANCEL_SUBS_LOWER_BY_HALF_EXPERIMENT = defineFcm(
	'revenue_cancel_subs_lower_by_half_experiment',
)
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				enabled: { type: 'boolean' },
				experiment_name: { type: 'string' },
			},
		}),
	)
	.withDefault(undefined)
	.toConfig({
		owner: 'squad-koi',
		scope: 'corgi-front-end',
		context: 'Account settings page - cancel subscription modal',
		description: 'This FCM config controls the cancel subscription upsell lower by half experiment.',
		import: false,
		template: {
			enabled: false,
			experiment_name: 'revenue_cancel_subs_lower_by_half',
		},
	});
